import axios, { endPoints } from 'utils/api';

const SET_LIST = 'questionnaires/SET_LIST';
const SET_DETAIL = 'questionnaires/SET_DETAIL';
const SET_VERSIONS = 'questionnaires/SET_VERSIONS';
const SET_LOADING = 'questionnaires/SET_LOADING';
const SET_ERROR = 'questionnaires/SET_ERROR';
const UPSERT_VERSION = 'questionnaires/UPSERT_VERSION';

export const setQuestionnairesList = (data) => ({ type: SET_LIST, data });
export const setQuestionnaireDetail = (data) => ({ type: SET_DETAIL, data });
export const setQuestionnaireVersions = (id, versions) => ({ type: SET_VERSIONS, id, versions });
export const setQuestionnairesLoading = (loading) => ({ type: SET_LOADING, loading });
export const setQuestionnairesError = (error) => ({ type: SET_ERROR, error });
export const upsertQuestionnaireVersion = (data) => ({ type: UPSERT_VERSION, data });

const INITIAL_STATE = {
    list: [],
    listLoading: false,
    listError: null,
    versions: {},
    detail: {}
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_LIST:
            return { ...state, list: [...action.data], listError: null };

        case SET_DETAIL: {
            const key = `${action.data.id}:${action.data.version}`;

            return { ...state, detail: { ...state.detail, [key]: action.data } };
        }

        case SET_VERSIONS:
            return {
                ...state,
                versions: { ...state.versions, [action.id]: [...action.versions] }
            };

        case SET_LOADING:
            return { ...state, listLoading: action.loading };

        case SET_ERROR:
            return { ...state, listError: action.error, listLoading: false };

        case UPSERT_VERSION: {
            const existing = state.versions[action.data.id] || [];
            const idx = existing.findIndex((v) => v.version === action.data.version);
            const nextVersions = idx >= 0
                ? existing.map((v, i) => i === idx ? action.data : v)
                : [...existing, action.data];

            return {
                ...state,
                versions: { ...state.versions, [action.data.id]: nextVersions }
            };
        }

        default:
            return state;
    }
}

export const fetchQuestionnaires = (params = {}) => async (dispatch) => {
    dispatch(setQuestionnairesLoading(true));

    try {
        const response = await axios.get(endPoints.questionnaires, { params });

        dispatch(setQuestionnairesList(response.data.data));
    } catch (error) {
        dispatch(setQuestionnairesError(error.message || 'Failed to load questionnaires'));
    } finally {
        dispatch(setQuestionnairesLoading(false));
    }
};

export const fetchQuestionnaireVersions = (id) => async (dispatch) => {
    const response = await axios.get(`${endPoints.questionnaires}/${id}/versions`);

    dispatch(setQuestionnaireVersions(id, response.data.data));

    return response.data.data;
};

export const fetchQuestionnaireVersion = (id, version) => async (dispatch) => {
    const response = await axios.get(`${endPoints.questionnaires}/${id}/versions/${version}`);

    dispatch(setQuestionnaireDetail(response.data));

    return response.data;
};

export const createQuestionnaire = (body) => async (dispatch) => {
    const response = await axios.post(endPoints.questionnaires, body);

    dispatch(upsertQuestionnaireVersion(response.data));
    dispatch(setQuestionnaireDetail(response.data));

    return response.data;
};

export const createQuestionnaireVersion = (id, body) => async (dispatch) => {
    const response = await axios.post(`${endPoints.questionnaires}/${id}/versions`, body);

    dispatch(upsertQuestionnaireVersion(response.data));
    dispatch(setQuestionnaireDetail(response.data));

    return response.data;
};

export const updateQuestionnaireDraft = (id, version, body) => async (dispatch) => {
    const response = await axios.put(
        `${endPoints.questionnaires}/${id}/versions/${version}`,
        body
    );

    dispatch(upsertQuestionnaireVersion(response.data));
    dispatch(setQuestionnaireDetail(response.data));

    return response.data;
};

export const transitionQuestionnaireStatus = (id, version, status) => async (dispatch) => {
    const response = await axios.patch(
        `${endPoints.questionnaires}/${id}/versions/${version}/status`,
        { status }
    );

    dispatch(upsertQuestionnaireVersion(response.data));
    dispatch(setQuestionnaireDetail(response.data));

    return response.data;
};
